export default "__VITE_ASSET__BaVq2AXQ__"